export default __webpack_public_path__ + "static/media/bell.b98add6d.svg";